import React from "react";
import PopupWin from "../../../../../components/PopupWin";
import { useEffect } from "react";


const ConnectToAceModal = ({ visible, onClose, onSave }) => {
  const [accessKeyId, setAccessKeyId] = React.useState("");
  const [secretAccessKey, setSecretAccessKey] = React.useState("");
  const [region, setRegion] = React.useState("");

  const [submitButtonLoading, setSubmitButtonLoading] = React.useState(false);

  const submitButtonDisabled = !accessKeyId || !secretAccessKey || !region || submitButtonLoading;

  const handleResetAll = () => {
    setAccessKeyId("");
    setSecretAccessKey("");
    setRegion("");

    setSubmitButtonLoading(false);
  }

  const handleSave = () => {
    setSubmitButtonLoading(true);
    onSave(
      {
        vendor: 'AWS',
        credential: {
          accessKeyId,
          secretAccessKey,
          region,
        },
      },
      // Callback to reset loading state
      () => {
        setSubmitButtonLoading(false);
      }
    );
  };

  const handleClose = () => {
    handleResetAll();
    onClose();
  }


  useEffect(() => {
    if (visible) {
      handleResetAll();
    }
  }, [visible]);

  return (
    <PopupWin
      visible={visible}
      onClose={onClose}
      hideClose={false}
      popupStyle={{
        width: "490px",
        minHeight: "558px",
        padding: 0,
        background: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
      }}
      contentStyle={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="connect-to-ace-modal">
        <h2 className="connect-to-ace-title">
          Save AWS ACE Connection Settings
        </h2>

        <div className="connect-to-ace-form-section">
          <label className="connect-to-ace-form-label">Access Key ID <span className="connect-to-ace-form-required">*</span></label>
          <input
            type="text"
            className="connect-to-ace-name-input"
            placeholder="Enter Access Key ID"
            value={accessKeyId}
            onChange={(e) => setAccessKeyId(e.target.value)}
          />
        </div>

        <div className="connect-to-ace-form-section">
          <label className="connect-to-ace-form-label">Secret Access Key <span className="connect-to-ace-form-required">*</span></label>
          <input
            type="text"
            className="connect-to-ace-name-input"
            placeholder="Enter Secret Access Key"
            value={secretAccessKey  }
            onChange={(e) => setSecretAccessKey(e.target.value)}
          />
        </div>

        <div className="connect-to-ace-form-section">
          <label className="connect-to-ace-form-label">Select Region <span className="connect-to-ace-form-required">*</span></label>
          <select className="connect-to-ace-name-select" value={region} onChange={(e) => setRegion(e.target.value)}>
            <option value="">Select Region</option>
            <>
              <option value="us-east-1">us-east-1</option>
              <option value="us-east-2">us-east-2</option>
              <option value="us-west-1">us-west-1</option>
              <option value="us-west-2">us-west-2</option>

              <option value="af-south-1">af-south-1</option>
              <option value="ap-east-1">ap-east-1</option>
              <option value="ap-south-1">ap-south-1</option>
              <option value="ap-south-2">ap-south-2</option>
              <option value="ap-southeast-1">ap-southeast-1</option>
              <option value="ap-southeast-2">ap-southeast-2</option>
              <option value="ap-southeast-3">ap-southeast-3</option>
              <option value="ap-southeast-4">ap-southeast-4</option>
              <option value="ap-northeast-1">ap-northeast-1</option>
              <option value="ap-northeast-2">ap-northeast-2</option>
              <option value="ap-northeast-3">ap-northeast-3</option>

              <option value="ca-central-1">ca-central-1</option>
              <option value="ca-west-1">ca-west-1</option>

              <option value="eu-central-1">eu-central-1</option>
              <option value="eu-central-2">eu-central-2</option>
              <option value="eu-west-1">eu-west-1</option>
              <option value="eu-west-2">eu-west-2</option>
              <option value="eu-west-3">eu-west-3</option>
              <option value="eu-north-1">eu-north-1</option>
              <option value="eu-south-1">eu-south-1</option>
              <option value="eu-south-2">eu-south-2</option>

              <option value="me-south-1">me-south-1</option>
              <option value="me-central-1">me-central-1</option>
              <option value="il-central-1">il-central-1</option>

              <option value="sa-east-1">sa-east-1</option>
            </>
          </select>
        </div>

        {/* Action Buttons */}
        <div className="connect-to-ace-modal-buttons">
          <button className="connect-to-ace-modal-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button disabled={submitButtonDisabled} className="connect-to-ace-modal-save" onClick={handleSave}>
            {submitButtonLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </PopupWin>
  );
};

export default ConnectToAceModal;
